export const menuPageTranslations = {
  nl: {
    title: "Ons Menu",
    subtitle: "Ontdek ons heerlijke assortiment vers bereide Surinaamse gerechten om te bestellen of af te halen. Eens per week bieden we ook Sri Lankaanse/Indiase gerechten aan, houd hiervoor onze <a href='https://chat.whatsapp.com/DkvPVnLDNfXJC8w1uBZAGO' target='_blank' rel='noopener noreferrer' class='text-primary underline hover:text-primary/80 font-semibold'>WhatsApp groep</a> in de gaten.",
    orderButton: "Direct Bestellen",
    allergiesTitle: "Allergieën of Dieetwensen?",
    allergiesText: "Informeer ons personeel over eventuele allergieën of speciale dieetwensen. We doen ons best om u tegemoet te komen. Prijzen zijn onder voorbehoud.",
    categories: {
      broodjes: "Broodjes",
      nasiBamiWitteRijst: "Nasi/Bami/Witte Rijst",
      roti: "Roti",
      voorgerechtenEnSnacks: "Voorgerechten & Snacks",
      extra: "Extra",
      dranken: "Dranken",
    },
    items: {
      kipKerrieBroodje: "KIP KERRIE",
      kipKetjapBroodje: "KIP KETJAP",
      lamsBroodje: "LAMS",
      eiBroodje: "EI",
      garnalenKousebandBroodje: "GARNALEN KOUSEBAND",
      bakkeljauwBroodje: "BAKKELJAUW",
      vegetarischBroodje: "VEGETARISCH",
      vegetarischBroodjeDesc: "(met aardappel en kouseband)",
      
      vegetarischNasi: "VEGETARISCH",
      vegetarischNasiDesc: "(met aardappel en kouseband)",
      kipsatePindasausNasi: "KIPSATÉ PINDASAUS",
      kipfiletKerrieNasi: "KIPFILET KERRIE",
      kipfiletKetjapNasi: "KIPFILET KETJAP",
      lamsNasi: "LAMS",
      garnalenNasi: "GARNALEN",

      vegetarischRotiNormaal: "VEGETARISCH",
      vegetarischRotiNormaalDesc: "Normaal: met aardappel en kouseband",
      vegetarischRotiSpeciaal: "VEGETARISCH",
      vegetarischRotiSpeciaalDesc: "Speciaal: grotere portie met een ei",
      kipfiletKerrieRotiNormaal: "KIPFILET KERRIE",
      kipfiletKerrieRotiNormaalDesc: "Normaal: met aardappel en kouseband",
      kipfiletKerrieRotiSpeciaal: "KIPFILET KERRIE",
      kipfiletKerrieRotiSpeciaalDesc: "Speciaal: grotere portie met een ei",
      kipfiletKetjapRotiNormaal: "KIPFILET KETJAP",
      kipfiletKetjapRotiNormaalDesc: "Normaal: met aardappel en kouseband",
      kipfiletKetjapRotiSpeciaal: "KIPFILET KETJAP",
      kipfiletKetjapRotiSpeciaalDesc: "Speciaal: grotere portie met een ei",
      kipMetBotRotiNormaal: "KIP (met bot)",
      kipMetBotRotiNormaalDesc: "Normaal: met aardappel en kouseband",
      kipMetBotRotiSpeciaal: "KIP (met bot)",
      kipMetBotRotiSpeciaalDesc: "Speciaal: grotere portie met een ei",
      lamsRotiNormaal: "LAMS",
      lamsRotiNormaalDesc: "Normaal: met aardappel en kouseband",
      lamsRotiSpeciaal: "LAMS",
      lamsRotiSpeciaalDesc: "Speciaal: grotere portie met een ei",

      baraSnack: "BARA",
      bakbanaanSnack: "BAKBANAAN",
      bakbanaanPindasausSnack: "BAKBANAAN PINDASAUS",
      teloBakkeljauwSnack: "TELO BAKKELJAUW",
      pitjelSnack: "PITJEL",
      kipsatePindasausSnack: "KIPSATÉ PINDASAUS",
      kipsateKetjapsausSnack: "KIPSATÉ KETJAPSAUS",
      saotoSoepSnack: "SAOTO SOEP",
      rotiRolKipSnack: "ROTI ROL KIP",
      rotiRolVegetarischSnack: "ROTI ROL VEGETARISCH",
      rotiRolLamsSnack: "ROTI ROL LAMS",

      losseRotiPlaatExtra: "LOSSE ROTI PLAAT",
      bakjePindasausExtra: "BAKJE PINDASAUS",
      bakjeKousebandExtra: "BAKJE KOUSEBAND",
      bakjeAardappelExtra: "BAKJE AARDAPPEL",
      bakjeWitteRijstExtra: "BAKJE WITTE RIJST",
      bakjeNasiBamiExtra: "BAKJE NASI/BAMI",
      bakjeKipfiletKerrieExtra: "BAKJE KIPFILET KERRIE",
      bakjeKipfiletKetjapExtra: "BAKJE KIPFILET KETJAP",
      bakjeLamsExtra: "BAKJE LAMS",
      
      colaDrank: "COLA/COLA ZERO",
      fantaDrank: "FANTA",
      chocomelDrank: "CHOCOMEEL",
      fernandesDrank: "FERNANDES (geel, groen, blauw, rood)",
      gemberBeerDrank: "GEMBER BEER",
      tropicalDrank: "TROPICAL",
      coconutJuiceDrank: "COCONUT JUICE",
      waterDrank: "WATER",
      mangoDrank: "MANGO",
    }
  },
  en: {
    title: "Our Menu",
    subtitle: "Discover our delicious range of freshly prepared Surinamese dishes to order or take away. Once a week we also offer Sri Lankan/Indian dishes, keep an eye on our <a href='https://chat.whatsapp.com/DkvPVnLDNfXJC8w1uBZAGO' target='_blank' rel='noopener noreferrer' class='text-primary underline hover:text-primary/80 font-semibold'>WhatsApp group</a> for this.",
    orderButton: "Order Directly",
    allergiesTitle: "Allergies or Dietary Wishes?",
    allergiesText: "Please inform our staff about any allergies or special dietary requirements. We do our best to accommodate you. Prices are subject to change.",
    categories: {
      broodjes: "Sandwiches",
      nasiBamiWitteRijst: "Nasi/Bami/White Rice",
      roti: "Roti",
      voorgerechtenEnSnacks: "Appetizers & Snacks",
      extra: "Extras",
      dranken: "Drinks",
    },
    items: {
      kipKerrieBroodje: "CHICKEN CURRY",
      kipKetjapBroodje: "CHICKEN KETJAP",
      lamsBroodje: "LAMB",
      eiBroodje: "EGG",
      garnalenKousebandBroodje: "SHRIMP GREEN BEANS",
      bakkeljauwBroodje: "SALTED COD",
      vegetarischBroodje: "VEGETARIAN",
      vegetarischBroodjeDesc: "(with potato and green beans)",

      vegetarischNasi: "VEGETARIAN",
      vegetarischNasiDesc: "(with potato and green beans)",
      kipsatePindasausNasi: "CHICKEN SATAY PEANUT SAUCE",
      kipfiletKerrieNasi: "CHICKEN FILLET CURRY",
      kipfiletKetjapNasi: "CHICKEN FILLET KETJAP",
      lamsNasi: "LAMB",
      garnalenNasi: "SHRIMP",

      vegetarischRotiNormaal: "VEGETARIAN",
      vegetarischRotiNormaalDesc: "Regular: with potato and green beans",
      vegetarischRotiSpeciaal: "VEGETARIAN",
      vegetarischRotiSpeciaalDesc: "Special: larger portion with an egg",
      kipfiletKerrieRotiNormaal: "CHICKEN FILLET CURRY",
      kipfiletKerrieRotiNormaalDesc: "Regular: with potato and green beans",
      kipfiletKerrieRotiSpeciaal: "CHICKEN FILLET CURRY",
      kipfiletKerrieRotiSpeciaalDesc: "Special: larger portion with an egg",
      kipfiletKetjapRotiNormaal: "CHICKEN FILLET KETJAP",
      kipfiletKetjapRotiNormaalDesc: "Regular: with potato and green beans",
      kipfiletKetjapRotiSpeciaal: "CHICKEN FILLET KETJAP",
      kipfiletKetjapRotiSpeciaalDesc: "Special: larger portion with an egg",
      kipMetBotRotiNormaal: "CHICKEN (bone-in)",
      kipMetBotRotiNormaalDesc: "Regular: with potato and green beans",
      kipMetBotRotiSpeciaal: "CHICKEN (bone-in)",
      kipMetBotRotiSpeciaalDesc: "Special: larger portion with an egg",
      lamsRotiNormaal: "LAMB",
      lamsRotiNormaalDesc: "Regular: with potato and green beans",
      lamsRotiSpeciaal: "LAMB",
      lamsRotiSpeciaalDesc: "Special: larger portion with an egg",

      baraSnack: "BARA",
      bakbanaanSnack: "PLANTAIN",
      bakbanaanPindasausSnack: "PLANTAIN PEANUT SAUCE",
      teloBakkeljauwSnack: "TELO SALTED COD",
      pitjelSnack: "PITJEL",
      kipsatePindasausSnack: "CHICKEN SATAY PEANUT SAUCE",
      kipsateKetjapsausSnack: "CHICKEN SATAY KETJAP SAUCE",
      saotoSoepSnack: "SAOTO SOUP",
      rotiRolKipSnack: "ROTI ROLL CHICKEN",
      rotiRolVegetarischSnack: "ROTI ROLL VEGETARIAN",
      rotiRolLamsSnack: "ROTI ROLL LAMB",

      losseRotiPlaatExtra: "LOOSE ROTI PLATE",
      bakjePindasausExtra: "CUP OF PEANUT SAUCE",
      bakjeKousebandExtra: "CUP OF GREEN BEANS",
      bakjeAardappelExtra: "CUP OF POTATO",
      bakjeWitteRijstExtra: "CUP OF WHITE RICE",
      bakjeNasiBamiExtra: "CUP OF NASI/BAMI",
      bakjeKipfiletKerrieExtra: "CUP OF CHICKEN FILLET CURRY",
      bakjeKipfiletKetjapExtra: "CUP OF CHICKEN FILLET KETJAP",
      bakjeLamsExtra: "CUP OF LAMB",
      
      colaDrank: "COKE/COKE ZERO",
      fantaDrank: "FANTA",
      chocomelDrank: "CHOCOLATE MILK",
      fernandesDrank: "FERNANDES (yellow, green, blue, red)",
      gemberBeerDrank: "GINGER BEER",
      tropicalDrank: "TROPICAL",
      coconutJuiceDrank: "COCONUT JUICE",
      waterDrank: "WATER",
      mangoDrank: "MANGO",
    }
  },
};